import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

export default function DragAndDrop({ children, onDragEnd, type }) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="items" type={type}>
        {provided => (
          <div ref={provided.innerRef}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
